import { Col, Row } from "reactstrap";
import { H3 } from "../../../AbstractElements";
import { FeaturedTutorials } from "../../../Constant";
import FaqFeaturesTutorial from "./FaqFeaturesTutorial";

const FAQFeaturesTutorial = () => {
  return (
    <Col lg="12" className="featured-tutorial">
      <div className="header-faq">
        <H3 className="mb-0">{FeaturedTutorials}</H3>
      </div>
      <Row>
        <FaqFeaturesTutorial />
      </Row>
    </Col>
  );
};
export default FAQFeaturesTutorial;
